import { LogoMsTeamsColored } from "components/icons/generated";
import setLocation from "shared/setLocation";
import { FederationProvider } from "types/generated";

import ConnectionCard from "../ConnectionCard";
import { PersonalConnectionsFederation } from "../gql";
import useExternalAccountsConnectionFeedback from "../useConnectionFeedback";
import {
  TEAMS_DESCRIPTION,
  TEAMS_LINK_ERROR_MESSAGES,
  TEAMS_LINK_GENERIC_ERROR,
  TEAMS_LINK_START_PATH,
} from "./constants";

type ExternalAccountsTeamsCardProps = {
  federation?: PersonalConnectionsFederation;
};

const ExternalAccountsTeamsCard = ({ federation }: ExternalAccountsTeamsCardProps) => {
  const { errorMessage } = useExternalAccountsConnectionFeedback({
    statusParam: "microsoft_teams_link",
    errorParam: "microsoft_teams_link_error",
    successMessage: "Microsoft Teams successfully linked.",
    errorMessages: TEAMS_LINK_ERROR_MESSAGES,
    genericError: TEAMS_LINK_GENERIC_ERROR,
  });

  return (
    <ConnectionCard
      icon={LogoMsTeamsColored}
      name="Microsoft Teams"
      provider={FederationProvider.MicrosoftTeamsOauth}
      description={TEAMS_DESCRIPTION}
      federation={federation}
      onConnect={() => setLocation(TEAMS_LINK_START_PATH)}
      errorMessage={errorMessage}
    />
  );
};

export default ExternalAccountsTeamsCard;
